import { Button, Col, Container, Row } from "react-bootstrap";
import LandingNavbar from "../landing/navbar.component";
import Footer from "../landing/footer.component";

export default function Promotion() {
  return (
    <div style={{ backgroundColor: "#000" }}>
      <img
        src="/images/landing-top.png"
        style={{ position: "absolute", top: 0, right: 0, zIndex: 0 }}
      />
      <Container style={{ zIndex: 100, position: "relative" }}>
        <LandingNavbar />

        <Row className="mb-5" style={{ paddingTop: 90, paddingBottom: 100 }}>
          <Col>
            <h1
              style={{
                fontWeight: 600,
                fontSize: "clamp(1.5rem, 2vw + 3rem, 5rem)",
                letterSpacing: "-1%",
              }}
              className="mb-3"
            >
              Focus on your
              <br />
              multiplayer game,
              <br />
              not the backend!
            </h1>
            <h2
              style={{
                fontWeight: 400,
                fontSize: "clamp(1.5rem, 2vw + 1rem, 3rem)",
              }}
              className="mb-5"
            >
              Grab{" "}
              <span
                style={{
                  fontSize: "clamp(1.5rem, 2vw + 1rem, 3rem)",
                  fontWeight: 900,
                  color: "#43FFB1",
                  transform: "rotate(10deg)",
                }}
              >
                80% off
              </span>{" "}
              premium plans.
            </h2>
            <div>
              <Button
                href="/register"
                className="mb-3"
                style={{ padding: "10px 42px" }}
              >
                REGISTER NOW
              </Button>
              <Button
                href="/pricing"
                className="mb-3"
                style={{ marginLeft: 10, padding: "10px 42px" }}
                variant="dark"
              >
                SEE PLANS
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      <Container
        style={{
          zIndex: 100,
          position: "relative",
        }}
      >
        <img
          src="/images/landing-banner.png"
          style={{ zIndex: 0, objectFit: "cover", width: "100%" }}
        />{" "}
        <Row className="mb-5" style={{ position: "absolute", top: 50 }}>
          <Col sm={12} lg={{ span: 6 }} style={{ zIndex: 5, padding: 50 }}>
            <h4 style={{ fontWeight: 500, fontSize: 27 }} className="mb-3">
              +15 Games
            </h4>
            <h3
              style={{
                fontWeight: 600,
                fontSize: "clamp(1.5rem, 2vw + 3rem, 5rem)",
              }}
              className="mb-3"
            >
              Powered by Dynamicpixels
            </h3>
            <p
              className="mb-5"
              style={{ fontWeight: 400, fontSize: 16, color: "#C1C1C1" }}
            >
              Dynamic Pixels is your complete backend solution for building
              online and multiplayer games. Focus on making great games. we’ll
              handle the heavy lifting.
            </p>
            <Button
              href="#!"
              style={{ marginLeft: 10, padding: "10px 42px" }}
              variant="light"
            >
              Get Started
            </Button>
          </Col>
        </Row>
      </Container>
      <Container style={{ zIndex: 100, position: "relative" }}>
        <Row className="mb-5">
          <img
            src="/images/landing-bg.png"
            style={{ position: "absolute", top: 0, right: 0, zIndex: 0 }}
          />
        </Row>
      </Container>

      <div
        style={{
          backgroundImage: "url(/images/landing-bg-2.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Row className="mb-5" style={{ paddingTop: 100 }}>
            <Col sm={12} lg={{ span: 6 }} className="mb-3">
              <h3
                style={{
                  fontWeight: 500,
                  fontSize: 42,
                }}
              >
                Everything
                <br /> You Need to
                <br /> Go Online
              </h3>
            </Col>
            <Col sm={12} lg={{ span: 6 }} className="mb-3">
              <img src="/images/landing-side-1.png" style={{ width: "100%" }} />
            </Col>
          </Row>
        </Container>
      </div>
      <Container style={{ zIndex: 100, position: "relative" }}>
        <Row className="mb-5">
          <Col
            sm={12}
            lg={{ span: 10, offset: 1 }}
            className="text-center mb-5"
          >
            <h2
              style={{
                fontWeight: 500,
                fontSize: "clamp(1.5rem, 2vw + 1.7rem, 6rem)",
              }}
            >
              Special Deal for Indie Studios:
              <br />
              Save Big on Dynamic Pixels
            </h2>
            <p style={{ fontWeight: 500, fontSize: 18 }}>
              Be among the first to experience our complete online services and
              enjoy <span style={{ color: "#43FFB1" }}>80% savings</span> on Pro
              and advanced plans.Act fast before this launch offer disappears!
            </p>
          </Col>
          <Col
            sm={12}
            lg={{ span: 8, offset: 2 }}
            className="mb-5"
            style={{
              background: "#000",
              borderRadius: 24,
              padding: 40,
              border: "1px solid #AEEBFF",
            }}
          >
            <Row>
              <Col sm={12} lg={6} className="mb-3">
                <h3
                  style={{
                    fontWeight: 400,
                    fontSize: 24,
                    lineHeight: "38px",
                    color: "rgba(255,255,255,0.88)",
                  }}
                  className="mb-3"
                >
                  Pro Plan
                </h3>
                <div className="price-box d-flex justify-content-start align-items-center mb-1">
                  <h3 style={{ fontSize: 44, fontWeight: 700 }}>$117.6</h3>
                  <span style={{ fontSize: 24, fontWeight: 500 }}>/year</span>
                </div>
                <div className="price-box d-flex justify-content-start align-items-center mb-5">
                  <h3
                    style={{ textDecoration: "line-through", fontWeight: 600 }}
                  >
                    $588
                  </h3>
                  <span style={{ fontSize: 16, fontWeight: 500 }}>/year</span>
                </div>
                <Button href="/register" style={{ padding: "10px 78px" }}>
                  Buy Now
                </Button>
              </Col>
              <Col sm={12} lg={6} className="mb-3">
                <span
                  style={{ fontWeight: 400, fontSize: 20, color: "#FFFFFFA6" }}
                >
                  This plan includes:
                </span>
                <ul style={{ fontSize: 18, marginLeft: 10 }}>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    10,000 MAU
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    20 tables
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    50 CCU
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    5GB data storage
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    Realtime Interactive service
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    In-game Chat Service
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <i
                      className="fa-solid fa-check"
                      style={{
                        color: "rgba(255,255,255,0.45)",
                        marginRight: 7,
                      }}
                    ></i>
                    Priority email support
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}
